import React from "react";

const Layout = ({ children }) => {
  return <>{children}</>;
};

Layout.Header = function Header({ children }) {
  return <header className="tendering-quotation__header">{children}</header>;
};

Layout.Content = function Content({ children, ...props }) {
  return (
    <main className={`tendering-quotation__content ${props.className}`}>
      {children}
    </main>
  );
};

Layout.Footer = function Footer({ children }) {
  return <footer className="tendering-quotation__footer">{children}</footer>;
};

export default Layout;
